import React, { useMemo } from 'react'

import CreateFormSelector from './CreateFormSelector'
import CombinedFacebookTikTokButton from './CombinedFacebookTikTokButton'
import FormDrawerWrapperComponent from '../../../features/components/FormDrawerWrapper'
import RightWrongDatesMessage from '../../../pages/RightsSummary/DigitalRight/UploadAdForms/RightWrongDatesMessage'

import useUploadAdCreativeConstants from '../UploadAdCreative/useUploadAdCreativeConstants'

// import { customConversionsWasLoadedSelector } from '../../../modules/selectors/choices'
// import {
//   partnerSelfAccountErrorSelector,
//   partnerSelfAccountWasLoadedSelector,
//   selfAccountErrorSelector,
//   selfAccountWasLoadedSelector
// } from '../../../modules/selectors/selfAccounts'
import { COMBINED_FACEBOOK_TIKTOK_CREATE } from '../../../constants/forms'

// Type-safe alias to avoid TypeScript errors with JS component
const FormDrawerWrapper = FormDrawerWrapperComponent as any

const CombinedFacebookTiktokCreate: React.FC = () => {
  // const customConversionsWasLoaded = useSelector(customConversionsWasLoadedSelector)
  // const selfAccountWasLoaded = useSelector(selfAccountWasLoadedSelector)
  // const selfAccountError = useSelector(selfAccountErrorSelector)
  // const partnerSelfAccountWasLoaded = useSelector(partnerSelfAccountWasLoadedSelector)
  // const partnerSelfAccountError = useSelector(partnerSelfAccountErrorSelector)

  const { isFormLoading: isUploadAdCreativeDataLoading, isRightEndDateInThePast } = useUploadAdCreativeConstants()

  // const selfAccountDidLoading = useMemo(
  //   () => selfAccountWasLoaded || selfAccountError,
  //   [selfAccountWasLoaded, selfAccountError]
  // )
  // const partnerSelfAccountDidLoading = useMemo(
  //   () => partnerSelfAccountWasLoaded || partnerSelfAccountError,
  //   [partnerSelfAccountWasLoaded, partnerSelfAccountError]
  // )

  // todo check and add tiktok loading
  const isFormLoading = useMemo(
    () => isUploadAdCreativeDataLoading,
    // todo revert - think of the react-query way to do this instead of redux
    // !customConversionsWasLoaded ||
    // !selfAccountDidLoading ||
    // !partnerSelfAccountDidLoading,
    [isUploadAdCreativeDataLoading]
  )

  console.log('isFormLoading', isFormLoading)

  return (
    <FormDrawerWrapper
      formName={COMBINED_FACEBOOK_TIKTOK_CREATE}
      title="Create social campaign"
      description="Configure the key settings for your social campaign, including platforms, objectives, targeting, budgets and ads."
      OpenDrawerTrigger={CombinedFacebookTikTokButton}
      isFormLoading={isFormLoading}
    >
      {/* todo implement SocialAuthChecker - determine how to do this for both tiktok and facebook */}
      {isRightEndDateInThePast ? <RightWrongDatesMessage /> : <CreateFormSelector />}
    </FormDrawerWrapper>
  )
}

export default CombinedFacebookTiktokCreate
